import './chat-iadvize.component.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopState } from '@agent/agent-interface/agent-desktop-routing.module';
import { IIAdvizeService } from '@agent/core/channel-digit/chat-iadvize/iadvize.service';
import { ChannelUtil } from '@commons/util/helper/channel';
import { IComponentController, IComponentOptions } from 'angular';
import { filter } from 'rxjs';

import { AgentChannelFacade } from '@contact/upgrade';

import templateUrl from './chat-iadvize.component.ajs.html';

const CHAT_CONTAINER_ID = 'Area-Chat';

class ChatIadvizeCtrl implements IComponentController {
  constructor(
    private readonly router: AgentDesktopRouter,
    private readonly iadvizeService: IIAdvizeService,
    private readonly agentChannelFacade: AgentChannelFacade
  ) {}

  $onInit(): void {
    const container = document.getElementById(CHAT_CONTAINER_ID);
    if (container) {
      this.iadvizeService.open().then(frame => frame.show(container));
    }

    this.agentChannelFacade
      .isActive(ChannelUtil.INCOMING_CHAT_IADVIZE)
      .pipe(filter(isActive => !isActive))
      .subscribe(_ => this.router.navigateToTile([AgentDesktopState.INFOS]));
  }

  $onDestroy(): void {
    this.iadvizeService.get().then(frame => frame.hide());
  }
}

export class ChatIadvize implements IComponentOptions {
  templateUrl = templateUrl;
  controller = ['agentDesktopRouter', 'iAdvizeService', 'agentChannelFacade', ChatIadvizeCtrl];
}

export default 'contactChatIadvize';
